import { useEffect, useRef } from 'react';
import { axiosInstance } from '../App';

/**
 * Periodically checks if the current session is still valid.
 * If another device logs in with the same user, the backend will
 * return 401 with SESSION_REPLACED, and the axios interceptor
 * will handle logout + redirect automatically.
 */
export const useSessionHeartbeat = (user) => {
  const intervalRef = useRef(null);
  const initialDelayRef = useRef(null);

  useEffect(() => {
    if (!user) {
      if (intervalRef.current) clearInterval(intervalRef.current);
      if (initialDelayRef.current) clearTimeout(initialDelayRef.current);
      return;
    }

    const checkSession = async () => {
      try {
        await axiosInstance.get('/auth/check-session');
      } catch (err) {
        // 401 is handled by the axios interceptor - no action needed here
      }
    };

    // Wait 5 seconds after login before starting session checks
    // This prevents race conditions during login flow
    initialDelayRef.current = setTimeout(() => {
      // Check every 30 seconds
      intervalRef.current = setInterval(checkSession, 30000);
    }, 5000);

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
      if (initialDelayRef.current) clearTimeout(initialDelayRef.current);
    };
  }, [user]);
};
